module.exports = __webpack_public_path__ + "5bf4196e5835752438ccfc1d4387bf70.pdf";